"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class IntegrationUserServiceApi extends runtime.BaseAPI {
    /**
     *  Deletes a connection made by an external user (e.g. slack) for integrating with Tableau
     * Deletes userConnection
     */
    userServiceDeleteUserConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
                throw new runtime.RequiredError('integrationId', 'Required parameter requestParameters.integrationId was null or undefined when calling userServiceDeleteUserConnection.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling userServiceDeleteUserConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/integrations/siteConnections/{integrationId}/userConnections/{id}`.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     *  Deletes a connection made by an external user (e.g. slack) for integrating with Tableau
     * Deletes userConnection
     */
    userServiceDeleteUserConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.userServiceDeleteUserConnectionRaw(requestParameters);
        });
    }
    /**
     * Fetches all connections to sites made by this integration external user
     * Get Tableau User Connections For Integration user
     */
    userServiceGetAllConnectedTableauUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.workflows.integration.auth.ExternalContext+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/integrations/userConnections`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauWorkflowsIntegrationAuthExternalContextToJSON(requestParameters.tableauWorkflowsIntegrationAuthExternalContext),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauWorkflowsIntegrationAuthConnectedUsersListFromJSON(jsonValue));
        });
    }
    /**
     * Fetches all connections to sites made by this integration external user
     * Get Tableau User Connections For Integration user
     */
    userServiceGetAllConnectedTableauUsers(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceGetAllConnectedTableauUsersRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.IntegrationUserServiceApi = IntegrationUserServiceApi;
